export enum mostSearchedLinksMenusKeys {
    ONLINE_TRUCK_BOOKING = "online-truck-booking",
    ONLINE_LOAD_BOOKING = "online-load-booking",
    TRANSPORTER = "transporter",
    TRANSPORT_SERVICE = "transport-service",
    TRANSPORT_DIRECTORY = "transport-directory",
    LORRY = "lorry"
}

export const mostSearchedLinksMenus = [
    { title: "Online Truck Booking", key: mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING },
    { title: "Online Load Booking", key: mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING },
    { title: "Transporters", key: mostSearchedLinksMenusKeys.TRANSPORTER },
    { title: "Major Routes", key: mostSearchedLinksMenusKeys.LORRY }
];
